class Carousel extends HTMLElement {
  constructor() {
    super();
    this.productSlider = this.getAttribute('data-product-slider') == 'true' ? true : false;
    this.productMedia = document.querySelector('.js-product-media');
    this.slider = this.querySelector(".js-carousel-slider");
    this.vertical = this.getAttribute("data-slider-vertical") == "true" ? true : false
    this.verticalDesktop = this.getAttribute("data-slider-vertical-desktop") == "true" ? true : false
    this.mq = [window.matchMedia('(min-width: 1201px)'), window.matchMedia('(min-width: 500px) and (max-width: 989px)')];
    this.comparisonTable = this.getAttribute('data-comparison-table') == "true" ? true : false;
    this.hotspots = this.getAttribute('data-hotspots') == "true" ? true : false;
    this.timeline = this.getAttribute('data-timeline') == "true" ? true : false;
    this.enableSliderLooping =
      this.getAttribute("data-slider-looping") == "true" ? true : false;
    this.enableSliderAutoplay =
      this.getAttribute("data-slider-autoplay") == "true" ? true : false;
    this.autoplaySpeed = this.getAttribute("data-slider-autoplay-speed")
      ? parseFloat(this.getAttribute("data-slider-autoplay-speed"))
      : 3000;
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');

    this.linkedPrevButton = document.querySelectorAll(`.js-carousel-linked-prev-button[data-linked-carousel="${this.id}"]`);
    this.linkedNextButton = document.querySelectorAll(`.js-carousel-linked-next-button[data-linked-carousel="${this.id}"]`);

    if (this.linkedPrevButton) {
      this.prevButton = [...this.prevButton, ...this.linkedPrevButton]
    }

    if (this.linkedNextButton) {
      this.nextButton = [...this.nextButton, ...this.linkedNextButton]
    }
    
    this.thumbSlider = this.getAttribute("data-slider-thumb")
      ? document.getElementById(this.getAttribute("data-slider-thumb"))
      : null;
    this.fullSlides =
      this.getAttribute("data-slider-items") == "1" ? true : false;
    this.delayInit =
      this.getAttribute("data-delay-init") == "true" ? true : false;

    if (!this.slider) return;
    if (this.delayInit) {
      this.addEventListener("trigger-init", () => {
        this.initPages();
      });
    } else {
      this.initPages();
    }
    
    const resizeObserver = new ResizeObserver((entries) => { this.resizeHandler() });
    resizeObserver.observe(this.slider);

    this.addEventListener('slider:go', (e) => {
      const index = e.detail.index;
      const skipCheck = e.detail.skipCheck ? e.detail.skipCheck : false;

      if (!index) return;

      this.scrollToSlide(index, skipCheck);

      if (e.detail.showSlider) {
        this.classList.remove('carousel--hidden');
      }
    });
  }

  isVertical() {
    if (this.vertical && this.verticalDesktop) {
      return this.mq.some((mq) => mq.matches);
    } else {
      return this.vertical;
    }
  }

  initPages() {    

    this.sliderItems = this.querySelectorAll(".js-carousel-slide");

    this.slider.addEventListener("scroll", this.update.bind(this));

    this.prevButton.forEach((el) => {
      el.addEventListener("click", this.onButtonClick.bind(this));
    });
    
    this.nextButton.forEach((el) => {
      el.addEventListener("click", this.onButtonClick.bind(this));
    });

    if (this.enableSliderAutoplay) this.autoplay();

    if (this.getAttribute("data-slider-for")) {
      const mainSlider = document.getElementById(
        this.getAttribute("data-slider-for")
      );
      this.sliderItems.forEach((slide) => {
        slide.addEventListener("click", () => {
          mainSlider.scrollToSlide(slide.getAttribute("data-slide-index"));
        });
      });
    }

    this.resizeHandler();
  }

  resizeHandler() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    
    if (this.comparisonTable) {
      const scrollPaddingLeft = this.sliderItems[0].clientWidth;
      this.slider.style.scrollPaddingLeft = `calc(${scrollPaddingLeft}px + 1rem)`;
    }

    if (this.sliderItemsToShow[1] && this.sliderItemsToShow[0]) {
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;

      if (this.isVertical()) {
        this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetTop -
        this.sliderItemsToShow[0].offsetTop;
      }

      this.slidesPerPage =
        Math.floor(this.slider.clientWidth / this.sliderItemOffset) + 1;

      if (this.classList.contains("carousel--show-to-edge")) {
        this.slidesPerPage -= 1;
      }
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }
  }

  update() {
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.isVertical()) {
      this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    }

    let currentSlide = this.currentPage;

    // Update Progress Bar
    let progressBar = this.querySelector('.progress-bar');
    let totalSlides = this.sliderItemsToShow.length;

    let twoAtOnce = this.getAttribute("data-show-two") == "true" ? true : false;

    if (twoAtOnce) {
      totalSlides = totalSlides - 1;
    }
    
    let slidesPerPage = this.getAttribute("data-items-per-page");
     
    if (progressBar) {
      let percentage = (100 / totalSlides) * currentSlide;

      // Multiply percentage by slidesPerPage if it exists
      if (slidesPerPage) {
        percentage *= parseInt(slidesPerPage, 10);
      }

      progressBar.style.setProperty('--progress-width', percentage + '%');
    }

    this.sliderItemsToShow.forEach((item, index) => {
      let thisSlide = index + 1;
      if (this.isSlideVisible(item) && thisSlide < currentSlide) {
        currentSlide = thisSlide;
      }
    });
    if (!this.enableSliderLooping) {
      this.prevButton.forEach((el) => {

        if (this.comparisonTable || this.hotspots || this.timeline) {
          if (this.slider.scrollLeft == 0) {
            el.setAttribute("disabled", "disabled");
          } else {
            el.removeAttribute("disabled");
          }
        } else {
          if (this.isSlideVisible(this.sliderItemsToShow[0])) {
            el.setAttribute("disabled", "disabled");
          } else {
            el.removeAttribute("disabled");
          }
        }
      })

      this.nextButton.forEach((el) => {
        if (
          this.isSlideVisible(
            this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
          )
        ) {
          el.setAttribute("disabled", "disabled");
        } else {
          el.removeAttribute("disabled");
        }
      })
    }

    if (this.thumbSlider) {
      this.updateThumb(currentSlide);
    }

    if (this.productSlider || this.timeline) {
      this.updateActiveSlide(currentSlide);
    }
    
    window.pauseMedia(this);

  }

  isSlideVisible(element, offset = 0) {
    if (element) {
      let lastVisibleSlide = Math.ceil(
        this.slider.clientWidth + this.slider.scrollLeft - offset
      );
      
      if (this.hotspots || this.timeline) {
        lastVisibleSlide = Math.ceil(
          this.slider.clientWidth + this.slider.scrollLeft + this.slider.offsetLeft - offset + 1
        );
      }

      if (this.isVertical()) {
        lastVisibleSlide = Math.ceil(
          this.slider.clientHeight + this.slider.scrollTop - offset
        );
      }

      if (this.isVertical()) {
        return (
          Math.floor(element.offsetTop + element.clientHeight) <= lastVisibleSlide &&
          Math.floor(element.offsetTop) >= Math.floor(this.slider.scrollTop)
        );
      }
      
      return (
        Math.floor(element.offsetLeft + element.clientWidth) <= lastVisibleSlide &&
        Math.floor(element.offsetLeft) >= Math.floor(this.slider.scrollLeft)
      );
    }
  }

  updateActiveSlide(slide) {
    this.lastSlideActive = false;

    if (this.productMedia) {
      this.productMedia.classList.remove('product__media--hide-labels');
    }

    this.sliderItems.forEach((el) => {
      el.classList.remove('active');
    })
    
    const activeSlide = this.sliderItems[slide - 1];
    
    if (!activeSlide) return;

    activeSlide.classList.add('active');

    const slideMedia = activeSlide.querySelectorAll('video, iframe, model-viewer');

    if (!slideMedia.length) return;

    if (this.productMedia) {
      this.productMedia.classList.add('product__media--hide-labels');
    }
  }

  updateThumb(slide) {
    const thumbSlides = this.thumbSlider.querySelectorAll(
      ".js-carousel-slide"
    );
    if (thumbSlides.length) {
      for (let index = 0; index < thumbSlides.length; index++) {
        let slideNumber = slide - 1;
        if (index == slideNumber) {
          thumbSlides[index].classList.add("active");
        } else {
          thumbSlides[index].classList.remove("active");
        }
      }

      if (typeof this.thumbSlider.scrollToSlide == "undefined") return;
      this.thumbSlider.scrollToSlide(slide);
    }
  }

  scrollToSlide(slide, skipCheck) {
    //check if slide is in view, if not, scroll to it
    if (!this.isSlideVisible(this.sliderItemsToShow[slide - 1]) || skipCheck) {
      this.slideScrollPosition = (slide - 1) * this.sliderItemOffset;
      
      if (this.isVertical()) {
        this.slider.scrollTo({
          top: this.slideScrollPosition,
        });
      } else {
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
      }
    }
  }

  onButtonClick(event, autoplay = false) {
    if (!autoplay) {
      event.preventDefault();
    }

    const step = event?.currentTarget?.dataset?.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (this.isVertical()) {
      this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;
    }

    if (
      this.currentPage == 1 &&
      event.currentTarget.name == "previous" &&
      this.enableSliderLooping
    ) {
      if (this.isVertical()) {
        this.slider.scrollTo({
          top: this.sliderItemsToShow.length * this.sliderItemOffset,
        });
      } else {
        this.slider.scrollTo({
          left: this.sliderItemsToShow.length * this.sliderItemOffset,
        });
      }
    } else if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      ) &&
      event.currentTarget.name == "next" &&
      this.enableSliderLooping
    ) {
      if (this.isVertical()) {
        this.slider.scrollTo({
          top: 0,
        });
      } else {
        this.slider.scrollTo({
          left: 0,
        });
      }
    } else {
      if (this.isVertical()) {
        this.slider.scrollTo({
          top: this.slideScrollPosition,
        });
      } else {
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
      }
    }
  }

  autoplay() {
    setInterval(() => {
      this.onButtonClick(
        {
          currentTarget: {
            name: "next",
          },
        },
        true
      );
    }, this.autoplaySpeed);
  }
}

customElements.define("carousel-slider", Carousel);
